(function () {
  function mirror(source, target) {
    target.innerHTML = source.innerHTML;
  }

  function init() {
    const source = document.getElementById('cart-icon-bubble');
    const target = document.getElementById('cart-icon-bubble-drawer');
    if (!source || !target) return;

    mirror(source, target);

    const observer = new MutationObserver(() => mirror(source, target));
    observer.observe(source, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
